import { UUID } from '../../../../core/pojo/id-variable';

export class PortfolioEvaluation {
  uuid: UUID;
  name: string;
  priority: number;
  ranking: EvaluationRanking;
  weight: number;
  comment: string;
  period: Date;
  companyUUID: string;
  companyName: string;

  constructor(name: string, priority: number, period: Date, companyUUID: string, companyName: string) {
    this.name = name;
    this.priority = priority;
    this.ranking = EvaluationRanking.NO_CHANGE;
    this.weight = DEFAULT_WEIGHT;
    this.period = period;
    this.companyUUID = companyUUID;
    this.companyName = companyName;
  }
}

export enum EvaluationRanking {
  SIGNIFICANTLY_WORSE = '1 (Significantly worse)',
  WORSE = '2 (Worse)',
  NO_CHANGE = '3 (No change)',
  BETTER = '4 (Better)',
  SIGNIFICANTLY_BETTER = '5 (Significantly better)',
}

export interface RankWithStyle {
  rank: EvaluationRanking;
  iconNameAndStylingLeft: string;
  rankingNumber: number;
}

export const EvaluationParameterNames = ['Sales, customers and revenue', 'Cash balance, burn rate, runway', 'Product', 'Market & Competition', 'Team'];
export const MAX_EVALUATION_COMMENT_SIZE = 500;
export const DEFAULT_WEIGHT = 0.2;
